import { render, staticRenderFns } from "./trans_fh.vue?vue&type=template&id=6b83d2d7&scoped=true"
import script from "./trans_fh.vue?vue&type=script&lang=js"
export * from "./trans_fh.vue?vue&type=script&lang=js"
import style0 from "./trans_fh.vue?vue&type=style&index=0&id=6b83d2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83d2d7",
  null
  
)

export default component.exports